export default {
  title: 'Recent Campaign Performance',
  recipients: '{{recipients}} Recipients',
  error_messages: {
    failed_to_load_data: 'Failed to load data',
  },
};
